import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
const Register = () => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const handleRegister = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate registration process
    setTimeout(() => {
      setIsLoading(false);
      navigate('/onboarding');
    }, 1500);
  };
  const handleLinkedInRegister = () => {
    setIsLoading(true);
    // Simulate LinkedIn registration process
    setTimeout(() => {
      setIsLoading(false);
      navigate('/onboarding');
    }, 1500);
  };
  return <div className="min-h-screen bg-black flex flex-col justify-center" data-id="element-3097">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-3098">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kYK3VqJh5ErppvW42Sa6wk/IMG_1178.png" alt="EIIS Logo" className="h-16 mx-auto" data-id="element-3099" />
        <h2 className="mt-6 text-center text-2xl font-bold text-white" data-id="element-3100">
          Crea il tuo account
        </h2>
        <p className="mt-2 text-center text-sm text-gray-400" data-id="element-3101">
          Registrati alla piattaforma EIIS per iniziare il tuo percorso
          formativo
        </p>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-3102">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" data-id="element-3103">
          <form className="space-y-6" onSubmit={handleRegister} data-id="element-3104">
            <div data-id="element-3105">
              <label htmlFor="fullName" className="block text-sm font-medium text-gray-700" data-id="element-3106">
                Nome e Cognome
              </label>
              <div className="mt-1" data-id="element-3107">
                <input id="fullName" name="fullName" type="text" autoComplete="name" required value={fullName} onChange={e => setFullName(e.target.value)} className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-custom-green focus:border-custom-green sm:text-sm" placeholder="Mario Rossi" data-id="element-3108" />
              </div>
            </div>
            <div data-id="element-3109">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-3110">
                Email
              </label>
              <div className="mt-1" data-id="element-3111">
                <input id="email" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-custom-green focus:border-custom-green sm:text-sm" placeholder="nome@esempio.it" data-id="element-3112" />
              </div>
            </div>
            <div data-id="element-3113">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-3114">
                Password
              </label>
              <div className="mt-1 relative" data-id="element-3115">
                <input id="password" name="password" type={showPassword ? 'text' : 'password'} autoComplete="new-password" required value={password} onChange={e => setPassword(e.target.value)} className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-custom-green focus:border-custom-green sm:text-sm" placeholder="••••••••" data-id="element-3116" />
                <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center" onClick={() => setShowPassword(!showPassword)} data-id="element-3117">
                  {showPassword ? <EyeOffIcon className="h-5 w-5 text-gray-400" data-id="element-3118" /> : <EyeIcon className="h-5 w-5 text-gray-400" data-id="element-3119" />}
                </button>
              </div>
            </div>
            <div data-id="element-3120">
              <button type="submit" disabled={isLoading} className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-custom-green hover:bg-custom-green/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-custom-green disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-3121">
                {isLoading ? 'Registrazione in corso...' : 'Registrati'}
              </button>
            </div>
          </form>
          <div className="mt-6" data-id="element-3122">
            <div className="relative" data-id="element-3123">
              <div className="absolute inset-0 flex items-center" data-id="element-3124">
                <div className="w-full border-t border-gray-300" data-id="element-3125"></div>
              </div>
              <div className="relative flex justify-center text-sm" data-id="element-3126">
                <span className="px-2 bg-white text-gray-500" data-id="element-3127">
                  Oppure continua con
                </span>
              </div>
            </div>
            <div className="mt-6" data-id="element-3128">
              <button onClick={handleLinkedInRegister} disabled={isLoading} className="w-full flex justify-center items-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#0A66C2] hover:bg-[#0A66C2]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0A66C2] disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-3129">
                LinkedIn
              </button>
            </div>
          </div>
          <div className="mt-6" data-id="element-3130">
            <p className="text-center text-xs text-gray-500" data-id="element-3131">
              Hai già un account?{' '}
              <Link to="/login" className="font-medium text-custom-green hover:text-custom-green/80" data-id="element-3132">
                Accedi
              </Link>
            </p>
          </div>
        </div>
      </div>
      <footer className="mt-8 text-center text-xs text-gray-400" data-id="element-3133">
        <p data-id="element-3134">
          © 2023 EIIS - European Institute for Innovation and Sustainability
        </p>
        <p className="mt-1" data-id="element-3135">
          <a href="#" className="text-custom-green hover:text-custom-green/80" data-id="element-3136">
            Privacy Policy
          </a>{' '}
          ·
          <a href="#" className="text-custom-green hover:text-custom-green/80 ml-2" data-id="element-3137">
            Termini di Servizio
          </a>
        </p>
      </footer>
    </div>;
};
export default Register;